import React, { useEffect, useState } from "react";
import profile from "../../Assets/Images/undraw_profile.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import axiosHttp from "../../Config";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import ReactPaginate from "react-paginate";
import ReusableModal from "../../Components/Modal";
import Feed from "../../Components/Feedback";

const Feedback = () => {
  const [feedbackList, setFeedbackList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageData, setPageData] = useState({
    currentPage: 1,
    totalPages: 1,
  });
  const [entries, setEntries] = useState(10);
  const [name, setName] = useState("satisfactory");
  const [showModal, setShowModal] = useState(false);
  const [singleFeedback, setSingleFeedback] = useState({});

  useEffect(() => {
    fetchFeedbackList(pageData.currentPage, entries, name);
  }, [pageData.currentPage, entries, name]);

  const fetchFeedbackList = async (current, count, name) => {
    setLoading(true);
    try {
      const getFeedbackList = await axiosHttp.get(
        `user-feedback?page=${current}&name=${name}&per_page=${count}`
      );
      if (getFeedbackList.status === 200) {
        let data = getFeedbackList.data.data;
        let page = getFeedbackList.data.meta;
        setPageData({
          currentPage: page.currentPage,
          totalPages: page.lastPage,
        });
        setFeedbackList(data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setFeedbackList([]);
      setLoading(false);
    }
  };

  const deleteHandler = async (id) => {
    setLoading(true);
    try {
      const deleteAdmin = await axiosHttp.delete(`admin/${id}`);
      if (deleteAdmin.status === 200) {
        setLoading(true);
        toast.success(deleteAdmin.data.message);
        fetchFeedbackList(pageData.currentPage, entries);
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
      setLoading(false);
    }
  };

  const handlePageClick = (event) => {
    setPageData({ ...pageData, currentPage: event.selected + 1 });
  };

  const openModal = (feed) => {
    setSingleFeedback(feed);
    setShowModal(true);
  };

  const closeModal = () => {
    setSingleFeedback({});
    setShowModal(false);
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="container-fluid top-container">
      <div className="card  card-one-1 mb-5">
        <div className="card-body">
          <h4 className="title mb-5">Feedback</h4>
          <div className="row mb-5">
            <div className="col-md-5">
              <h5 className="head">Feedback List</h5>
            </div>
            <div className="col-md-4 text-right">
              <select
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
              >
                <option value="satisfactory">Satisfactory</option>
                <option value="Queries were unresolved">
                  Queries were unresolved
                </option>
                <option value="Call quality issues - Audio">
                  Call quality issues - Audio
                </option>
                <option value="Call quality issues - Video">
                  Call quality issues - Video
                </option>
                <option value="Call quality issues - Connectivity">
                  Call quality issues - Connectivity
                </option>
                <option value="Absent participation by other attendees">
                  Absent participation by other attendees
                </option>
                <option value="Others">Others</option>
                <option value="definitely">Definitely</option>
                <option value="Call quality concerns - Audio">
                  Call quality concerns - Audio
                </option>
                <option value="Call quality concerns - Video">
                  Call quality concerns - Video
                </option>
                <option value="Call quality concerns - Connectivity">
                  Call quality concerns - Connectivity
                </option>
                <option value="Lack of participation by others">
                  Lack of participation by others
                </option>
                <option value="highly_likely">Highly Likely</option>
                <option value="Challenges with user-friendliness">
                  Challenges with user-friendliness
                </option>
              </select>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-sm-12 col-md-6">
              <label className="d-flex align-items-center">
                Show{" "}
                <select
                  className="form-control entry-select ml-2 mr-2"
                  value={entries}
                  onChange={(e) => setEntries(Number(e.target.value))}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                entries
              </label>
            </div>
          </div>
          <div className="table-responsive">
            <table
              className="table table-bordered"
              id="dataTable"
              width="100%"
              cellspacing="0"
            >
              <thead className="bg-col">
                <tr>
                  <th className="border-right-0 ">
                    <input
                      type="checkbox"
                      className="form-control check-box "
                    />
                  </th>
                  <th className="border-right-0 ">User name</th>
                  <th className="border-right-0 ">Feedback</th>
                  <th className="border-right-0 ">Action</th>
                </tr>
              </thead>
              <tbody>
                {feedbackList.length === 0 && (
                  <p className="mt-2">No Data Available</p>
                )}
                {feedbackList.length > 0 &&
                  feedbackList.map((feed) => {
                    return (
                      <tr key={feed?.id}>
                        <td className="text-center border-right-0 ">
                          <input
                            type="checkbox"
                            className="form-control check-box "
                          />
                        </td>
                        <td className="border-right-0 ">
                          <img
                            className="img-profile rounded-circle photo mr-2"
                            src={
                              feed?.mentee_pic_url
                                ? feed?.mentee_pic_url
                                : profile
                            }
                            alt="profile"
                          />{" "}
                          {feed?.mentee_name}
                        </td>
                        <td className="border-right-0 ">{feed?.description}</td>

                        <td>
                          <span>
                            <FontAwesomeIcon
                              icon={faEye}
                              className="bg-success text-white p-1 rounded mr-3 cursor-pointer"
                              onClick={() => openModal(feed)}
                            />
                          </span>
                          <span onClick={() => deleteHandler(feed?.user_id)}>
                            <FontAwesomeIcon
                              icon={faTrashAlt}
                              className="bg-danger text-white p-1 rounded mr-3 cursor-pointer"
                            />
                          </span>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          {pageData.totalPages > 1 && (
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageData.totalPages}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination justify-content-end"
              activeClassName="active"
              previousLabel="<"
              forcePage={pageData.currentPage - 1}
            />
          )}
        </div>
      </div>
      <ReusableModal
        show={showModal}
        onHide={closeModal}
        title="View Feedback Detail"
        size="lg"
      >
        <Feed feed={singleFeedback} />
      </ReusableModal>
    </div>
  );
};

export default Feedback;
